import Element from "element-ui"
import axios from "axios";
import router from "./router";
//  let locationUrl =  sessionStorage.getItem('area')
// if(locationUrl == null){
//     axios.defaults.baseURL = "http://192.168.31.113:8081/hg/";
// }else{
//     axios.defaults.baseURL = "http://192.168.31.113:8081/"+locationUrl+ "/";
// }
//  axios.defaults.baseURL = "http://hgyl.hk952183.com/"+ locationUrl;
//     axios.defaults.baseURL = "http://47.96.28.227:8081/"+ locationUrl;

const request = axios.create({
    //timeout: 5000,
    headers: {
        'Content-Type': "application/json; charset=utf-8"
    },
    // baseURL:"http://192.168.31.113:8081/hg/"
     baseURL:"http://47.96.28.227:8081/hg/"
})

request.interceptors.request.use(config => {
    config.headers['Authorization'] = localStorage.getItem("token")
   let url =   JSON.parse(localStorage.getItem("userInfo"));
    if(url!=null && typeof url.param != 'undefined'){
        // config.baseURL =  "http://192.168.31.113:8081/"+url.param + "/";//本地环境
        config.baseURL = "http://47.96.28.227:8081/"+url.param + "/"; //线上环境
    }else{
        // config.baseURL="http://192.168.31.113:8081/hg/"; //本地环境
        config.baseURL = "http://47.96.28.227:8081/hg/"; //线上环境
    }
  //   if(sessionStorage.getItem('area')!= null){
  //       config.baseURL =  "http://192.168.31.113:8081/"+sessionStorage.getItem('area')+ "/"
  //   }else{
  //       config.baseURL="http://192.168.31.113:8081/hg/"
  //   }
    return config
})

request.interceptors.response.use(
    response => {


        let res = response.data

        if (res.code === 200) {
            return response
        } else {
            Element.Message.error(!res.msg ? '系统异常' : res.msg)
            return Promise.reject(response.data.msg)
        }
    },
    error => {


        if (error.response.data) {
            error.massage = error.response.data.msg
        }
        if (error.response.status === 401) {
            router.push("/")
        }

        // Element.Message.error(error.massage, {duration: 3000})
        // return Promise.reject(error)
    }
)

export default request
